<template>
<div :class="$style['refundment-content']">
    <table>
        <tr>
            <td>商品名称：</td>
            <td>{{orderDetail.goods_name}}</td>
        </tr>
        <tr>
            <td>申请{{titleLabel}}金额：</td>
            <td :class="$style['refund-amount']" v-if="isIntegralRefund">{{orderDetail.refund_points + '分'}}</td>
            <td :class="$style['refund-amount']" v-else>{{orderDetail.refund_amount&&'¥'+orderDetail.refund_amount}}</td>
        </tr>
        <tr>
            <td>{{titleLabel}}方式：</td>
            <td>{{orderDetail.refundmentType}}</td>
        </tr>
        <!-- <tr>
            <td>实际退款金额：</td>
            <td>
                <wt-input :class="$style['number-input-price']" v-model="form.actualMoney"><el-button slot="append" >¥</el-button></wt-input>
            </td>
        </tr> -->
        <tr v-if="!isIntegralRefund">
            <td><div><span></span><span :class="$style['is-required']">*</span></div>退款途径：</td>
            <td>
                <wt-radio :radios="refundMode" v-model="form.processMode" :class="$style['refund-radio']" data-vv-as="退款方式"
            name="refundMode"  v-validate="'required'"></wt-radio>
            </td>
        </tr>
        <tr v-if="!isIntegralRefund">
            <td></td>
            <td :class="$style['refund-mode-text']">在选择线下退款前，请确保已完成相关的实际退款操作！
                <div :class="$style['refund-mode-text']"></div>
                </td>
        </tr>
    </table>
    <div :class="$style['button-div']">
        <el-button type="primary" @click="refund" :loading="loading">{{titleLabel}}</el-button>
        <el-button  type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import formMixins from 'mixins/form'
import { cashCount } from '@/utils/formUtils'
import { refundMode } from '../goods-order-options'
export default {
  mixins: [formMixins],
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isIntegralRefund: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleLabel () {
      return this.isIntegralRefund ? '退还积分' : '退款'
    }
  },
  data () {
    return {
      form: {
      },
      loading: false,
      refundMode: refundMode
    }
  },
  watch: {
    'orderDetail.canRefundOffline': {
      handler: function (val) {
        if (!val) {
          this.refundMode.forEach(item => {
            if (item.value === 'MANUAL') {
              item.disabled = true
            }
          })
        } else {
          this.refundMode.forEach(item => {
            item.disabled = false
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    refund () {
      let data = {
        actualMoney: cashCount(this.form.actualMoney),
        mallOrderId: this.orderDetail.id,
        processMode: this.form.processMode
      }
      if (this.isIntegralRefund) {
        data = {
          amount: this.form.actualMoney,
          mode: 'AUTO',
          pointsOrderId: this.orderDetail.id
        }
      }
      let ajaxUrl = this.isIntegralRefund ? 'approvalRefundmentIntegral' : 'approvalRefundment'
      this.validate('form').then(formValue => {
        this.loading = true
        this.$store.dispatch(ajaxUrl, data).then(res => {
          this.$message.success('审批' + this.titleLabel + '成功')
          this.$emit('close', true)
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '审批' + this.titleLabel + '失败')
        })
      })
    }
  }
}
</script>
<style module lang="less">
@import "~less/var.less";
.refund-radio{
    justify-content: flex-start!important;
    :global
    .el-radio-group{
        .el-radio{
            display: flex;
        justify-content: flex-start!important;
         align-items: center;
         line-height: normal
        }
    }
    *{
         justify-content: flex-start!important;
         align-items: center;
         line-height: normal
    }
}
.refundment-content{
    :global
    table{
        tr{
            :first-child{
                display: flex;
                justify-content: flex-end;
                line-height: 40px;
                color: #606266!important;
                white-space: nowrap;
            }
            :last-child{
                color: @mainColor
            }

        }
    }

}
.is-required{
    color: red!important;
    margin-right: 3px;
}
.refund-amount{
    font-size: 16px;
    font-weight: 600
}
.number-input-price{
    max-width: 200px;
    color: #000!important;
    :global
    .el-input-group__append{
        width: 50PX;
        padding:0;
        display: flex;
        justify-content: center;
        align-content: center;
        .el-button{
            padding: 0;
            span{
                color: @tipTextColor!important;
            }
        }
    }
}
.button-div{
    margin-top:25px;
    :global
    .el-button{
        margin-right: 40px;
    }
}
.refund-mode-text{
    color: red!important;
    line-height:20px;
}
</style>
